export const ANALYTICS = 'analytics';
export const BUYER_MARKETPLACE = 'buyer_marketplace';
export const CREDIT_CONTROL = 'credit_control';
export const LEAD = 'lead_management';
export const LEADV2 = 'lead_management_v2';
export const LOAN_TRACKER = 'loan_tracker';
export const MARKETPLACE = 'markertplace';
export const SHOWROOM = 'showroom';
export const COMMISSION_TRACKER = 'commission_tracker';
export const EINVOICE = 'einvoice';



// WEBPACK FOOTER //
// ./src/constants/apps.js